export default function CatalogPreview() {
  const categories = [
    {
      title: 'Revestimientos Premium',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20marble%20and%20ceramic%20tiles%20display%20in%20professional%20showroom%20with%20various%20premium%20wall%20and%20floor%20covering%20materials%2C%20elegant%20stone%20textures%2C%20modern%20porcelain%20tiles%2C%20sophisticated%20patterns%2C%20clean%20white%20background%20highlighting%20quality%20construction%20materials&width=600&height=400&seq=catalog-zhongming-003&orientation=landscape',
      items: ['Mármol Natural', 'Porcelánico Técnico', 'Piedra Natural', 'Cerámica de Diseño']
    },
    {
      title: 'Pavimentos Técnicos',
      image: 'https://readdy.ai/api/search-image?query=High-end%20flooring%20materials%20showcase%20featuring%20luxury%20wood%20parquet%2C%20engineered%20hardwood%20floors%2C%20premium%20laminate%20samples%2C%20and%20technical%20flooring%20solutions%20displayed%20professionally%20in%20construction%20materials%20warehouse%20with%20clean%20organized%20presentation&width=600&height=400&seq=catalog-zhongming-004&orientation=landscape',
      items: ['Tarima Flotante', 'Suelo Laminado', 'Parquet Multicapa', 'Suelo Vinílico']
    },
    {
      title: 'Sanitarios y Grifería',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bathroom%20fixtures%20and%20faucets%20display%20in%20professional%20showroom%2C%20premium%20sanitary%20ware%20including%20contemporary%20toilets%2C%20elegant%20sinks%2C%20designer%20faucets%2C%20chrome%20and%20matte%20black%20finishes%2C%20minimalist%20design%20with%20clean%20white%20background&width=600&height=400&seq=catalog-zhongming-005&orientation=landscape',
      items: ['Inodoros Suspendidos', 'Lavabos de Diseño', 'Grifería Premium', 'Duchas Modernas']
    },
    {
      title: 'Iluminación Arquitectónica',
      image: 'https://readdy.ai/api/search-image?query=Architectural%20lighting%20fixtures%20collection%20in%20professional%20setting%2C%20modern%20LED%20lights%2C%20designer%20pendant%20lamps%2C%20contemporary%20chandeliers%2C%20track%20lighting%20systems%2C%20elegant%20wall%20sconces%2C%20sophisticated%20commercial%20lighting%20solutions%20with%20clean%20presentation&width=600&height=400&seq=catalog-zhongming-006&orientation=landscape',
      items: ['LED Integrado', 'Lámparas Decorativas', 'Iluminación Técnica', 'Sistemas Smart']
    },
    {
      title: 'Carpintería y Puertas',
      image: 'https://readdy.ai/api/search-image?query=Premium%20interior%20doors%20and%20carpentry%20products%20showcase%2C%20modern%20wooden%20doors%2C%20contemporary%20door%20designs%2C%20quality%20wood%20finishes%2C%20professional%20carpentry%20materials%2C%20elegant%20door%20handles%20and%20hardware%2C%20clean%20showroom%20display%20with%20natural%20wood%20tones&width=600&height=400&seq=catalog-zhongming-007&orientation=landscape',
      items: ['Puertas Lacadas', 'Puertas de Madera', 'Armarios Empotrados', 'Herrajes Premium']
    },
    {
      title: 'Materiales Fachada',
      image: 'https://readdy.ai/api/search-image?query=Modern%20facade%20materials%20and%20cladding%20systems%20display%2C%20contemporary%20building%20exterior%20materials%2C%20aluminum%20composite%20panels%2C%20ventilated%20facade%20systems%2C%20architectural%20cladding%20solutions%2C%20professional%20construction%20materials%20with%20clean%20industrial%20presentation&width=600&height=400&seq=catalog-zhongming-008&orientation=landscape',
      items: ['Panel Composite', 'Fachada Ventilada', 'Revestimiento Exterior', 'Sistemas de Anclaje']
    }
  ];

  return (
    <section id="catalog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-lock-line mr-2"></i>
            Catálogo Exclusivo B2B
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
            Amplia Gama de Productos Premium
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Accede a nuestro extenso catálogo de materiales de construcción y decoración importados directamente desde China. Calidad certificada y precios competitivos para profesionales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
          {categories.map((category, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white">{category.title}</h3>
              </div>
              <div className="p-6">
                <ul className="space-y-2 mb-6">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-blue-900 mr-2 w-5 h-5 flex items-center justify-center"></i>
                      <span className="text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
                <button className="w-full bg-blue-50 text-blue-900 py-3 rounded-lg font-semibold hover:bg-blue-900 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-information-line mr-2"></i>
                  Solicitar Información
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-900 to-blue-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <i className="ri-file-list-3-line text-5xl mb-4"></i>
          <h3 className="text-3xl font-bold mb-4">¿Necesitas el Catálogo Completo?</h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Solicita acceso a nuestro catálogo profesional completo con especificaciones técnicas, certificaciones y precios especiales para mayoristas.
          </p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer inline-block"
          >
            <i className="ri-download-cloud-line mr-2"></i>
            Solicitar Catálogo Profesional
          </button>
        </div>
      </div>
    </section>
  );
}
